import { render, staticRenderFns } from "./myOrganisationSitesTable.vue?vue&type=template&id=a946612a&scoped=true&"
import script from "./myOrganisationSitesTable.vue?vue&type=script&lang=js&"
export * from "./myOrganisationSitesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a946612a",
  null
  
)

export default component.exports